(function () {
  // Optional navigation effects must never block the storefront's first paint.
  const ua = navigator.userAgent || '';
  const appleWebKit = /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) ||
    (/Safari/i.test(ua) && !/Chrome|Chromium|Edg|OPR|Android/i.test(ua));
  const inApp = (/\bAndroid\b/i.test(ua) && /;\s?wv\)/i.test(ua)) ||
    /\b(FBAN|FBAV|FB_IAB|FBIOS|Instagram|musical_ly|Bytedance|BytedanceWebview|trill|TikTok)(?:\b|_)/i.test(ua);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const lowPower = Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;

  if (window.baysDisableViewTransitions || appleWebKit || inApp || reducedMotion.matches || lowPower) {
    const style = document.createElement('style');
    style.textContent = '@view-transition { navigation: none; }';
    document.head.appendChild(style);
    return;
  }

  function skip(transition) {
    if (!transition || reducedMotion.matches ||
        typeof transition.types?.add !== 'function' || typeof transition.types?.clear !== 'function') {
      transition?.skipTransition();
      return true;
    }
    return false;
  }

  window.addEventListener('pageswap', (event) => {
    const transition = event.viewTransition;
    if (skip(transition)) return;

    const cancel = () => transition.skipTransition();
    document.addEventListener('pointerdown', cancel, { once: true });
    document.addEventListener('keydown', cancel, { once: true });
    const removeListeners = () => {
      document.removeEventListener('pointerdown', cancel);
      document.removeEventListener('keydown', cancel);
    };
    transition.finished.then(removeListeners, removeListeners);

    document.querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => element.removeAttribute('data-view-transition-type'));
    const type = document.querySelector('[data-view-transition-triggered]')?.getAttribute('data-view-transition-type');
    try {
      if (type) sessionStorage.setItem('custom-transition-type', type);
      else sessionStorage.removeItem('custom-transition-type');
    } catch {
      transition.skipTransition();
      return;
    }
    transition.types.clear();
    transition.types.add(type || 'page-navigation');
  });

  window.addEventListener('pagereveal', async (event) => {
    const transition = event.viewTransition;
    const activation = window.navigation?.activation;
    if (activation && (activation.from === null || activation.navigationType === 'reload')) {
      transition?.skipTransition();
      return;
    }
    if (skip(transition)) return;

    let type;
    try {
      type = sessionStorage.getItem('custom-transition-type');
    } catch {
      transition.skipTransition();
      return;
    }
    transition.types.clear();
    transition.types.add(type || 'page-navigation');
    if (!type) return;

    try {
      await transition.finished;
    } catch {
      // Navigation can proceed without its decorative snapshot.
    } finally {
      transition.types.clear();
      transition.types.add('page-navigation');
      try {
        sessionStorage.removeItem('custom-transition-type');
      } catch {
        // Storage is optional; always remove the temporary DOM attributes.
      }
      document.querySelectorAll('[data-view-transition-type]')
        .forEach((element) => element.removeAttribute('data-view-transition-type'));
    }
  });
})();
